import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { MatSnackBar, MatDialog, MatTableDataSource, MatSort, MatPaginator } from '@angular/material';
import { Store } from '@ngrx/store';
import { UserService } from 'src/app/services/user.service';
import { NgxSpinnerService } from 'ngx-spinner';
import * as FormActions from '../../reducers/actions/forms.actions';
import { Form, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { PerfilComponent } from '../perfil/perfil.component';
import * as moment from 'moment';
import { RutValidator } from 'ng2-rut';
import { CertificadosService } from 'src/app/services/certificados.service';
import { Solicitante_certificado } from 'src/app/models/solicitante_certificado.model';

declare const swal: any;

interface AppState {
  form: Form;
}

@Component({
  selector: 'app-seguimiento-certificados',
  templateUrl: './seguimiento-certificados.component.html',
  styleUrls: ['./seguimiento-certificados.component.css'],
  providers: [CertificadosService]
})
export class SeguimientoCertificadosComponent implements OnInit {
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  public certificado_info
  public arreglo
  buscando = false
  public fecha_ingreso = new FormControl('', [Validators.required]);
  displayedColumns: string[] = ['nsoli', 'fecha_ingreso', 'rol', 'direc', 'certificado', 'estado', 'opcion'];
  dataSource
  busquedaFormGroup: FormGroup;

  username
  userrut



  identity
  token

  constructor(private _snackBar: MatSnackBar, private dialog: MatDialog, private store: Store<AppState>,
    private _cert: CertificadosService, private spinner: NgxSpinnerService, private _cd: ChangeDetectorRef,
    private rutValidator: RutValidator, private _formBuilder: FormBuilder) {

    this.busquedaFormGroup = this._formBuilder.group({
      rut: ['', [Validators.required, this.rutValidator]],
    })

  }

  ngOnInit() {

  }

  ngAfterViewInit() {
  }

  ngDoCheck() {
    // this.dataSource.paginator = this.paginator;
    // this.dataSource.sort = this.sort;

  }


  filtrar(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  get_certificado() {
    this.spinner.show()
    this._cert.get_certificado(this.busquedaFormGroup.controls.rut.value).subscribe(response => {
      console.log(response)
      let datos = []

      this.username = response.body.response.data[0].fieldData['Adm_Solicitantes::Sol_Nom_Sol_Emp']
      this.userrut = response.body.response.data[0].fieldData['Tramite_Solicitudes::_TRA_Sol_Rut'] + "-" + response.body.response.data[0].fieldData['Adm_Solicitantes::Sol_DV']

      for (let i = 0; i < response.body.response.data.length; i++) {
        const element = response.body.response.data[i].fieldData;
        datos.push(element)
      }
      this.dataSource = new MatTableDataSource(datos);
      console.log(this.dataSource)
      this.buscando = true
      this.spinner.hide()

      // var fechax, fechaCertificado
      // if (response.certificado.length > 0) {
      //   this.certificado_info = response.certificado
      //   console.log(this.certificado_info)
      //   this.buscando = true
      //   this.spinner.hide()

      //   var arreglox = [];

      //   this.certificado_info.forEach((element, index) => {

      //     if (index == 0) {
      //       this.arreglo = [{
      //         rol: element.fieldData['Propiedad 2::Pro_Propie_ROL'],
      //         data: []
      //       }]

      //       arreglox.push(element.fieldData['Propiedad 2::Pro_Propie_ROL']);
      //       this.arreglo[index]['data'].push({
      //         nomCertificado: element.fieldData['Tramites 5::TRAEXP_Tipo'],
      //         direccion: element.fieldData['Propiedad_Direccion 2::PDI_Direc_Completa'],
      //         estado: element.fieldData['TRACER_Estado_Descripcion']
      //       })
      //     } else {
      //       let rolactual = element.fieldData['Propiedad 2::Pro_Propie_ROL']
      //       if (arreglox.indexOf(rolactual) !== -1) {

      //         /* OK, value exists! */
      //         let indexActual = arreglox.indexOf(rolactual)
      //         console.log(indexActual)
      //         console.log("ya existe el rol dentro")

      //         this.arreglo[indexActual]['data'].push({
      //           nomCertificado: element.fieldData['Tramites 5::TRAEXP_Tipo'],
      //           direccion: element.fieldData['Propiedad_Direccion 2::PDI_Direc_Completa'],
      //           estado: element.fieldData['TRACER_Estado_Descripcion']
      //         })
      //       } else {


      //         var arregl2
      //         arregl2 = [{
      //           rol: element.fieldData['Propiedad 2::Pro_Propie_ROL'],
      //           data: []
      //         }]

      //         arregl2[0]['data'].push({
      //           nomCertificado: element.fieldData['Tramites 5::TRAEXP_Tipo'],
      //           direccion: element.fieldData['Propiedad_Direccion 2::PDI_Direc_Completa'],
      //           estado: element.fieldData['TRACER_Estado_Descripcion']
      //         })

      //         Array.prototype.push.apply(this.arreglo, arregl2);
      //       }


      //     }



      //   });

      //   console.log(this.arreglo)


      //   fechax = this.certificado_info[0].fieldData.zz_Ingreso_Fecha_Hora
      //   fechaCertificado = moment(fechax).format("DD/MM/YYYY");
      //   this.certificado_info[0].fieldData.zz_Ingreso_Fecha_Hora = fechaCertificado

      // } else {
      //   this.spinner.hide()
      //   swal({
      //     type: 'warning',
      //     title: 'Atención!',
      //     text: "No se encontraron registros de certificados con ese numero de solicitud",
      //     confirmButtonColor: '#3F51B5',
      //     confirmButtonText: 'Aceptar',
      //     timer: 3500
      //   }).then(() => {
      //   }, (dismiss) => {
      //     if (dismiss === 'timer') {
      //     }
      //   });
      // }

    }, error => {
      console.log(error)
    })

  }

  getDoc(certificado) {
    this.spinner.show()
    console.log(certificado)
    this._cert.get_Doc_cert(certificado).subscribe(resp => {
      this.spinner.hide()

      console.log("respuesta get doc", resp)
      if (resp.code == '200') {
        let anio = certificado.TRACER_Fecha_Ingreso.split("/")

        const linkSource = 'data:application/pdf;base64,' + resp.resp.Documento
        const downloadLink = document.createElement("a");
        const fileName = certificado.TRACER_Cert_Tipo + "-" + certificado._TRACER_ID + "-" + anio[2] + ".pdf";

        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
        swal({
          type: 'success',
          title: 'Descargado!',
          text: "Se ha descargado su certificado",
          confirmButtonColor: '#3F51B5',
          confirmButtonText: 'Aceptar',
          // timer: 3500,
          onClose: () => {
            this.buscando = false
            this.busquedaFormGroup.reset()
          }
        }).then(() => {
        }, (dismiss) => {
          this.buscando = false
          this.busquedaFormGroup.reset()
          if (dismiss === 'timer') {
            this.buscando = false
            this.busquedaFormGroup.reset()
          }
        });


      } if (resp.code == '500') {
        console.log("ha ocurrido un problema", resp.resp)
        swal({
          type: 'warning',
          title: 'Atención!',
          text: "Ha ocurrido un problema al descargar su certificado.",
          confirmButtonColor: '#3F51B5',
          confirmButtonText: 'Aceptar',
          // timer: 3500,
          onClose: () => {
            this.buscando = false
            this.busquedaFormGroup.reset()
          }
        }).then(() => {
        }, (dismiss) => {
          this.buscando = false
          this.busquedaFormGroup.reset()
          if (dismiss === 'timer') {
            this.buscando = false
            this.busquedaFormGroup.reset()
          }
        });
      }


    }, error => {
      console.log("error en get doc", error)
    })

  }

  logout() {
    this.store.dispatch(new FormActions.FormUpdate('0', ''))
    sessionStorage.removeItem("identity-domCloud");
    sessionStorage.removeItem("token-domCloud");
    this._snackBar.open("Se ha cerrado sesión", "Cerrar", {
      duration: 3000,
    });


  }

  openPerfil() {
    this.dialog.open(PerfilComponent)
  }

  volver() {
    this.buscando = false
    this.busquedaFormGroup.reset()

  }

}
